import { ethers } from "ethers";
import { nils, getv, iso } from "@/utils/utils";
import {
  getContract,
  prepareContractCall,
  sendTransaction,
  waitForReceipt,
} from "thirdweb";
import { thirdweb_client, use_chain } from "@/views/ThirdWebLogin";
import _ from "lodash";

const polygon = use_chain;

export class CV2_Contract {
  constructor({ contract_k, contractAddress, aumode, abi, ...ext }) {
    this.contract_k = contract_k;
    this.contractAddress = contractAddress;

    this.provider = new ethers.JsonRpcProvider(polygon.rpc);
    this.signer = null;

    this.abi = abi;
    this.abi_map = _.keyBy(this.abi, "name");

    this.contract = new ethers.Contract(
      this.contractAddress,
      this.abi,
      this.provider, // Use provider for view functions
    );
    this.aumode = aumode;
    if (aumode == "thirdweb") {
      this.active_account = ext.active_account;
    }
    // console.log(this);
  }
  async getParsedLogs(logs, tx) {
    let parsed_logs = [];
    return tx;
  }

  async wait(tx) {
    tx = await waitForReceipt({
      client: thirdweb_client,
      transactionHash: tx.transactionHash,
      chain: polygon,
    });
    tx.hash = tx.transactionHash;
    tx.parsed_logs = await this.getParsedLogs(tx.logs, tx);
    return tx;
  }

  async run(method, args, info = {}) {
    let inf = this.abi_map[method];
    if (!inf) {
      // console.log(`>${this.contract_k} method=${method} not found`);
      return null;
    }
    let is_only_data = inf.stateMutability === "view";
    // console.log(`run:contract=${this.contract_k}`, { method, args, info, });

    let wait = getv(info, "wait") ?? true;
    // console.log({ is_only_data, wait, });

    if (is_only_data) {
      // console.log("run:is_only_data", method, args, this.abi_map[method]);
      let tx = await this.contract[method](...args);
      return tx;
    } else {
      let contract = await getContract({
        address: this.contractAddress,
        chain: polygon,
        client: thirdweb_client,
      });
      // console.log("getContract", contract);
      // console.log("abi_method", this.abi_map[method]);
      let tx = await prepareContractCall({
        contract,
        method: this.abi_map[method],
        // method:
        //   "function createBet( string memory _encoded, uint _betamt, string memory token) public",
        params: args,
      });
      // console.log("prepareContractCall", tx);
      tx = await sendTransaction({
        account: this.active_account,
        transaction: tx,
      });
      // console.log("send_txn", tx);
      // console.log(`method:${method} txhash:`, tx.hash);
      tx.hash = tx.transactionHash;
      if (wait) {
        await this.wait(tx);
      }
      return tx;
    }
  }
}
